export var LOADING_LABEL = ', Loading';